import React from 'react';
import classes from './ReviewSection.module.scss';
import { DateHelper } from '@/utils/helpers';
import StarRating from '@/components/Resources/StarRating/StarRating';
import t from '@/utils/Language/OrganizationPage-translations';

const ReviewListItem = ({ reviewItem, resource, isOwnReview }) => {
  return (
    <div className={classes.reviewItem}>
      <div className={classes.reviewItemRating}>
        <StarRating stars={reviewItem?.related_overall_rating} />
      </div>
      <p>"{reviewItem?.content}"</p>
      <h6>
        {isOwnReview ? t('You') : t('Member')} - {DateHelper.formatDate(reviewItem.created_at)}
      </h6>
      {reviewItem?.commentable_type === 'Opportunity' && resource?.resource_type !== 'Opportunity' && (
        <a href={`/opp/${reviewItem.opp_slug}`} target="_blank">
          {reviewItem?.opp_title}
        </a>
      )}
      {reviewItem?.commentable_type === 'Organization' && (
        <a href={`/org/${resource.slug}`} target="_blank">
          {resource?.name}
        </a>
      )}
    </div>
  );
};

export default ReviewListItem;
